import { Sparkles } from 'lucide-react';

/**
 * Insignia estándar de IA (principio 3 del rediseño: TODO lo que use AI la lleva).
 * Contract Validation, Policy Reader, Analyze with AI, drafts del inbox, etc.
 * "AI" es marca, no texto traducible — igual en EN y ES.
 */
export function AiBadge({ title }: { title?: string }) {
  return (
    <span className="ai-chip" title={title}>
      <Sparkles size={11} strokeWidth={2} />
      AI
    </span>
  );
}
